import React,{useMemo,useState} from 'react';
import {PrepEventBrowser,PrepDialog} from '../event-prep/PrepWorkspace';
import {usePrepTeam} from '../event-prep/useEventPrep';
import {prepEvents} from '../event-prep/prepModel';
import {resolveSetupEvent,setupKey} from '../../utils/eventSetup';
import EventWorkspace from '../event-workspace/EventWorkspace';
import {plannerEventKey} from '../planning/plannerEvents';
// Legacy prep deep links open the same event-owned editor used by Home cards.
export default function HomeEventPrep({teamId,target,onClose}) {
  const model=usePrepTeam(true,teamId),[selected,setSelected]=useState(null);
  const events=useMemo(()=>{const split=prepEvents(model.team?.events||[]);return [...split.upcoming,...split.past];},[model.team]);
  const key=selected||target,occurrence=/^(.*)__(\d{4}-\d{2}-\d{2})$/.exec(key||'');
  const event=key==='choose'?null:events.find(event=>plannerEventKey(event)===key)||resolveSetupEvent(model.team?.events||[],occurrence?setupKey({eventId:occurrence[1],instanceDate:occurrence[2]}):key);
  if(event&&!model.loading&&!model.error)return <EventWorkspace event={{...event,__teamId:teamId,calendar:'team'}} onClose={onClose}/>;
  return <PrepDialog event={{note:'Choose an event'}} input={false} onClose={onClose}>
    <header className="PrepDialog__header"><h2>Event Prep</h2><button type="button" onClick={onClose} aria-label="Close Event Prep">×</button></header>
    {model.loading?<p role="status">Loading your team events…</p>:model.error?<p role="alert">{model.error}</p>:<>
      {target!=='choose'&&<p role="status">That event is no longer available. Choose another event below.</p>}
      <PrepEventBrowser events={model.team?.events||[]} onSelect={event=>setSelected(plannerEventKey(event))}/>
    </>}
  </PrepDialog>;
}
